// src/pages/AGB.jsx
import React from 'react';
import '../styles/AGB.css';

const AGB = () => {
    return (
        <div className="agb-container">
            <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>

            <section className="agb-section">
                <h2>Einleitung</h2>
                <p>
                    Bitte lesen Sie diese Allgemeinen Geschäftsbedingungen sorgfältig durch, bevor Sie unser Online-Bestellsystem nutzen.
                    Mit dem Zugriff oder der Nutzung des Systems erklären Sie sich mit den nachstehenden Bedingungen einverstanden.
                    Wenn Sie diesen Bestimmungen nicht zustimmen, dürfen Sie unser System nicht verwenden.
                </p>
            </section>

            <section className="agb-section">
                <h2>Zweck</h2>
                <p>
                    Unser Online-Bestellsystem bietet Ihnen die Möglichkeit, Speisen und Getränke bequem zur Lieferung oder Abholung zu bestellen.
                    Die Nutzung erfolgt ausschließlich gemäß diesen AGB.
                </p>
            </section>

            <section className="agb-section">
                <h2>Haftungsausschluss</h2>
                <p>
                    Das System wird „wie besehen“ bereitgestellt. Wir übernehmen keine Gewähr für Richtigkeit, Funktionalität oder Verfügbarkeit.
                    Die Nutzung erfolgt auf eigenes Risiko. Änderungen oder Unterbrechungen des Dienstes können jederzeit ohne Vorankündigung erfolgen.
                </p>
                <p>
                    Unsere Haftung ist – soweit gesetzlich zulässig – auf 100 € begrenzt. Dies gilt nicht für Schäden aus Verletzung von Leben, Körper oder Gesundheit,
                    die auf unsere Fahrlässigkeit zurückzuführen sind.
                </p>
            </section>

            <section className="agb-section">
                <h2>Verwendung von Zahlungsdaten</h2>
                <p>
                    Ihre Zahlungsinformationen werden ausschließlich von einem sicheren externen Zahlungsdienstleister verarbeitet.
                    Wir selbst speichern keine vollständigen Zahlungsdaten, sondern lediglich die letzten vier Ziffern Ihrer Karte zur Identifizierung der Transaktion.
                </p>
                <p>
                    Name, Telefonnummer und Adresse dienen ausschließlich der ordnungsgemäßen Durchführung Ihrer Bestellung.
                </p>
            </section>

            <section className="agb-section">
                <h2>Bestellungen & Zahlung</h2>
                <p>
                    Bitte prüfen Sie jede Bestellung sorgfältig, bevor Sie diese absenden.
                    Eine Bestellung gilt erst als angenommen, wenn Sie eine Bestätigung von uns erhalten haben.
                    Wir behalten uns vor, Bestellungen abzulehnen oder zu stornieren, sofern falsche Angaben gemacht wurden oder unvorhersehbare Umstände eintreten.
                </p>
                <p>
                    Sie sind für die Richtigkeit Ihrer persönlichen Angaben verantwortlich und haften für alle über Ihr Gerät getätigten Bestellungen.
                    Preisänderungen oder Produktanpassungen können jederzeit erfolgen.
                </p>
            </section>

            <section className="agb-section">
                <h2>Nutzerpflichten</h2>
                <p>
                    Sie verpflichten sich, das Online-Bestellsystem nur im Rahmen der gesetzlichen Bestimmungen zu nutzen.
                    Untersagt sind insbesondere falsche Bestellungen, die Nutzung automatisierter Systeme sowie jegliche Manipulation oder Störung des Dienstes.
                </p>
                <p>
                    Eine Nutzung des Systems für rechtswidrige oder nicht genehmigte Zwecke ist untersagt.
                </p>
            </section>

            <section className="agb-section">
                <h2>Kommunikation</h2>
                <p>
                    Die Kommunikation zwischen Ihnen und uns kann elektronisch erfolgen.
                    Elektronische Mitteilungen gelten als rechtlich gleichwertig zur Schriftform.
                </p>
            </section>

            <section className="agb-section">
                <h2>Stornierungen</h2>
                <p>
                    Wir behalten uns vor, Bestellungen zu stornieren, wenn unrichtige Angaben gemacht wurden oder Ereignisse außerhalb unserer Kontrolle
                    die Ausführung verhindern.
                </p>
            </section>

            <section className="agb-section">
                <h2>Kündigung</h2>
                <p>
                    Sowohl Sie als auch wir können die Nutzung des Online-Bestellsystems jederzeit ohne Vorankündigung beenden.
                    Nach Beendigung erlischt Ihr Nutzungsrecht.
                </p>
            </section>

            <section className="agb-section">
                <h2>Geltendes Recht</h2>
                <p>
                    Diese AGB unterliegen dem Recht der Bundesrepublik Deutschland.
                    Für alle Streitigkeiten ist ausschließlich das zuständige Gericht in Deutschland am Sitz der Hello Charge Restaurant GmbH zuständig.
                </p>
            </section>

            <section className="agb-section">
                <h2>Kontakt</h2>
                <p>
                    Bei Fragen, Kommentaren oder Beschwerden wenden Sie sich bitte an:
                </p>
                <p>
                    <strong>Hello Charge Restaurant GmbH</strong><br />
                    Huttenstraße 68<br />
                    10553 Berlin<br />
                    E-Mail: info@hellocharge.de
                </p>
            </section>

            <p className="agb-source">
                © {new Date().getFullYear()} Hello Charge Restaurant GmbH. Alle Rechte vorbehalten.
            </p>
        </div>
    );
};

export default AGB;
